<template>
  <div class="min-h-screen w-full bg-white">
    <!-- Split Layout -->
    <div class="grid lg:grid-cols-2 min-h-screen">
      <!-- Left Side - Visual Section -->
      <div class="flex flex-col items-center justify-center p-8 bg-gradient-to-br from-gray-50 to-gray-100">
        <div class="flex items-center justify-center">
          <svg viewBox="0 0 100 100" class="w-64 h-64">
            <circle cx="50" cy="50" r="45" fill="none" stroke="#FC002B" stroke-width="2" class="animate-pulse-slow"/>
            <text x="50" y="55" font-size="24" fill="#FC002B" text-anchor="middle" class="font-bold">
              404
            </text>
          </svg>
        </div>
      </div>

      <!-- Right Side - Content -->
      <div class="flex flex-col items-center justify-center p-8">
        <div class="max-w-md w-full">
          <!-- Logo at the top -->
          <div class="flex justify-start mb-8">
            <img :src="require('@/assets/logo/logoB.svg')" alt="logo" class="h-12"/>
          </div>

          <!-- Content -->
          <div class="space-y-8">
            <div class="space-y-4">
              <h1 class="text-4xl font-bold text-gray-900">
                {{ t('notFound.title') }} </h1>
              <p class="text-gray-600">
                {{ t('notFound.description') }} </p>
            </div>

            <!-- Buttons -->
            <div class="flex flex-col space-y-4">
              <CustomButton :button-text="t('notFound.backToHome')" color="primary" size="lg" full-width @click="router.push('/')"/>
              <CustomButton :button-text="t('notFound.contactSupport')" color="primary" variation="outline" size="lg" full-width @click="handleContactSupport"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import CustomButton from '@/components/base/buttons/VButton.vue'

const router = useRouter()
const { t } = useI18n()

const handleContactSupport = () => {
  window.open('mailto:support@lobsterlead.com', '_blank')
}
</script>

<style scoped>
.animate-pulse-slow {
  animation: pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
}
</style>